import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ChevronRightSmallOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ChevronRightSmallOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M11.59 7.5H9.1l3.32 4.5-3.32 4.5h2.49L14.9 12l-3.31-4.5Z" fill="currentColor" />
    </svg>;
}) as ForwardedIconComponent);
export default ChevronRightSmallOutlined;